export default {
  remove: 'Remove',
  retry: 'Retry',
  revoke: 'Revoke'
}
